(function($) {
	"use strict";

	// **************************************
	//      DROPDOWN MOBILE FIX
	// **************************************

	window.applangaHelpers.executeWhenExist('.website-header', 25, 250, function() {
		// Fix issue that it was not possible to click on submenu items on mobile devices
		// because it directly redirected to another page
		$(".dropdown > a").click(function(event) {
			if( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) {
				// Is mobile device so do not open the link. Just display the menu
				event.stopPropagation();
				event.preventDefault();
			}
		});
	});

})(jQuery);
